{
    "power" : [
        "-1",
        "+1"
    ]
}